import { Backdrop, CircularProgress, makeStyles, Theme, createStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        loadingOverlay: {
            position: 'absolute',
            display: 'flex',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            background: 'rgb(255,255,255,0.7)',
            padding: theme.spacing(1),
            zIndex: 15
        }
    }),
);

interface FormLoadingSpinnerProps {
    disableShrink?: boolean;
}

const FormLoadingSpinner = (props: FormLoadingSpinnerProps) => {

    const classes = useStyles();

    return (
        <Backdrop open={true} className={classes.loadingOverlay}>
            <CircularProgress disableShrink={props.disableShrink} />
        </Backdrop>
    );
}

export default FormLoadingSpinner;